import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";

const Infraestructura = ({ infraestructura, setInfraestructura, finalizada }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfraestructura((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const asNumberOrNull = (value) => {
    if (value === "" || value === null || value === undefined) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12}>
        <SoftTypography variant="h4" fontWeight="bold">
          Infraestructura
        </SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <Grid container spacing={1} p={2}>
            {/* Campos del formulario */}
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="diasLaborales">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Días Laborales (Mes)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="diasLaborales"
                name="diasLaborales"
                placeholder="Ingrese los días laborales"
                value={asNumberOrNull(infraestructura.diasLaborales)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadDeEmpleados">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad de Empleados
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadDeEmpleados"
                name="cantidadDeEmpleados"
                placeholder="Ingrese la cantidad de empleados"
                value={asNumberOrNull(infraestructura.cantidadDeEmpleados)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="aguaPotable">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Agua Potable (m³ anuales)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="aguaPotable"
                name="aguaPotable"
                placeholder="Ingrese el agua potable"
                value={asNumberOrNull(infraestructura.aguaPotable)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="aguaProcesoIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Agua Proceso Industrial (m³ anuales)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="aguaProcesoIndustrial"
                name="aguaProcesoIndustrial"
                placeholder="Ingrese el agua de proceso industrial"
                value={asNumberOrNull(infraestructura.aguaProcesoIndustrial)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <InputLabel htmlFor="potable">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Potable
                </SoftTypography>
              </InputLabel>
              <Select
                id="potable"
                name="potable"
                value={infraestructura.potable || ""}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value="De red">De red</MenuItem>
                <MenuItem value="Otra">Otra</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={8}>
              <InputLabel htmlFor="especificacionPotable">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Especificación Potable
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="especificacionPotable"
                name="especificacionPotable"
                placeholder="Ingrese la especificación potable"
                value={infraestructura.especificacionPotable || ""}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <InputLabel htmlFor="cruda">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cruda
                </SoftTypography>
              </InputLabel>
              <Select
                id="cruda"
                name="cruda"
                value={infraestructura.cruda || ""}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value="Superficial">Superficial</MenuItem>
                <MenuItem value="Perforación propia">Perforación propia</MenuItem>
                <MenuItem value="Perforación no propia">Perforación no propia</MenuItem>
                <MenuItem value="Acueducto">Acueducto</MenuItem>
                <MenuItem value="Camión cisterna">Camión cisterna</MenuItem>
                <MenuItem value="Otra">Otra</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={8}>
              <InputLabel htmlFor="especificacionCruda">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Especificación Cruda
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="especificacionCruda"
                name="especificacionCruda"
                placeholder="Ingrese la especificación cruda"
                value={infraestructura.especificacionCruda || ""}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="conexionCloacal">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Conexión cloacal
                </SoftTypography>
              </InputLabel>
              <Select
                id="conexionCloacal"
                name="conexionCloacal"
                value={infraestructura.conexionCloacal || false}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value={true}>Si</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadConexionCloacal">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad de conexión cloacal (m³)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadConexionCloacal"
                name="cantidadConexionCloacal"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.cantidadConexionCloacal)}
                onChange={handleChange}
                disabled={!infraestructura.conexionCloacal || finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="pozoAbsorvente">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Pozo absorvente
                </SoftTypography>
              </InputLabel>
              <Select
                id="pozoAbsorvente"
                name="pozoAbsorvente"
                value={infraestructura.pozoAbsorvente || false}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value={true}>Si</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadPozoAbsorvente">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad pozo absorvente (m³)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadPozoAbsorvente"
                name="cantidadPozoAbsorvente"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.cantidadPozoAbsorvente)}
                onChange={handleChange}
                disabled={!infraestructura.pozoAbsorvente || finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="piletasLagunasDeTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Piletas/Lagunas de Tratamiento
                </SoftTypography>
              </InputLabel>
              <Select
                id="piletasLagunasDeTratamiento"
                name="piletasLagunasDeTratamiento"
                value={infraestructura.piletasLagunasDeTratamiento || false}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value={true}>Si</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadPiletasLagunasDeTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad (m³)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadPiletasLagunasDeTratamiento"
                name="cantidadPiletasLagunasDeTratamiento"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.cantidadPiletasLagunasDeTratamiento)}
                onChange={handleChange}
                disabled={!infraestructura.piletasLagunasDeTratamiento || finalizada}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="plantaTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Planta de tratamiento de efluentes
                </SoftTypography>
              </InputLabel>
              <Select
                id="plantaTratamiento"
                name="plantaTratamiento"
                value={infraestructura.plantaTratamiento || false}
                onChange={handleChange}
                displayEmpty
                disabled={finalizada}
              >
                <MenuItem value={true}>Si</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadPlantaTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad (m³)
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadPlantaTratamiento"
                name="cantidadPlantaTratamiento"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.cantidadPlantaTratamiento)}
                onChange={handleChange}
                disabled={!infraestructura.plantaTratamiento || finalizada}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <InputLabel htmlFor="aguaNoIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Destino Agua NO industrial
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="aguaNoIndustrial"
                name="aguaNoIndustrial"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.aguaNoIndustrial)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={8}>
              <InputLabel htmlFor="observacionAguaNoIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Observación Agua NO industrial
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="observacionAguaNoIndustrial"
                name="observacionAguaNoIndustrial"
                placeholder="Ingrese observación"
                value={infraestructura.observacionAguaNoIndustrial || ""}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <InputLabel htmlFor="aguaIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Destino Agua industrial
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="aguaIndustrial"
                name="aguaIndustrial"
                placeholder="Ingrese cantidad"
                value={asNumberOrNull(infraestructura.aguaIndustrial)}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={6} md={8}>
              <InputLabel htmlFor="observacionAguaIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Observación Agua industrial
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="observacionAguaIndustrial"
                name="observacionAguaIndustrial"
                placeholder="Ingrese observación"
                value={infraestructura.observacionAguaIndustrial || ""}
                onChange={handleChange}
                disabled={finalizada}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="descripcionProcesoIndustrial">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Descripción del Proceso Industrial
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="descripcionProcesoIndustrial"
                name="descripcionProcesoIndustrial"
                placeholder="Ingrese la descripción del proceso industrial"
                value={infraestructura.descripcionProcesoIndustrial || ""}
                onChange={handleChange}
                multiline
                rows={2}
                disabled={finalizada}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

Infraestructura.propTypes = {
  infraestructura: PropTypes.object.isRequired,
  setInfraestructura: PropTypes.func.isRequired,
  finalizada: PropTypes.bool,
};

export default Infraestructura;
